import React, { useCallback } from "react";
import { connect } from "react-redux";

import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { faEye } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons/faEyeSlash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { useIntl } from "react-intl";

import { Activity, Resource } from "@mapmycustomers/shared/types/entity";
import formatFileSize from "@mapmycustomers/shared/util/formatters/formatFileSize";
import { Button, FileIcon } from "@mapmycustomers/ui";

import { downloadFile } from "@app/store/files/actions";

import styles from "./ResourceItem.module.scss";

interface ResourceItemProps {
  activity: Activity;
  resource: Resource;
}

const ResourceItem = ({
  activity,
  onDownloadFile,
  resource,
}: ResourceItemProps & typeof mapDispatchToProps) => {
  const intl = useIntl();

  const handleDownload = useCallback(() => {
    onDownloadFile({ fileId: resource.file!.id, fileName: resource.name });
  }, [resource, onDownloadFile]);

  const emailResource = activity.emailLog?.resources?.find(
    (emailResource) => emailResource.fileId === resource.file?.id
  );

  if (!resource.file || !emailResource) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.resourceContainer}>
        {<FileIcon className={styles.resourceFileIcon} file={resource.file} />}
        <div className={styles.resourceName}>
          <div className={styles.resourceNamePure}>{resource.name}</div>
          <div className={styles.resourceNameExtra}>
            <span>({formatFileSize(resource.file.contentLength ?? 0)})</span>
          </div>
        </div>
        <span className={styles.resourceActions}>
          <Tooltip
            title={intl.formatMessage({
              id: "component.activityAnnotation.resourcesSection.downloadResourceTooltip",
              defaultMessage: "Download resource",
              description: "Tooltip for download resource button in activity resources section",
            })}
          >
            <Button
              className={styles.downloadButton}
              disabled={!resource?.file}
              icon={<FontAwesomeIcon icon={faDownload} />}
              iconOnly
              onClick={handleDownload}
              type="text"
            />
          </Tooltip>
        </span>
      </div>
      {
        <FontAwesomeIcon
          className={cn(styles.resourceOpenStatusIcon, { [styles.opened]: emailResource.opened })}
          icon={emailResource.opened ? faEye : faEyeSlash}
        />
      }
    </div>
  );
};

const mapDispatchToProps = {
  onDownloadFile: downloadFile,
};

export default connect(null, mapDispatchToProps)(ResourceItem);
